// filepath: /Users/marielamagallon/Desktop/mycinemadb/src/components/Home.js
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';

// config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
// components
import HeroImage from './HeroImage';
import Grid from './Grid';
import Thumb from './Thumb';
import Spinner from './Spinner';
import SearchBar from './SearchBar';
import Button from './Button';

// hook
import { useHomeFetch } from '../hooks/useHomeFetch';

// image
import NoImage from '../images/no_image.jpg';

const Home = () => {
    const { state, loading, error, searchTerm, setSearchTerm, setIsLoadingMore } = useHomeFetch();

    console.log('State:', state);

    if (error) return <div>Something went wrong...</div>;

    return (
        <Fragment>
            <Helmet>
                <title>MyCinemaDB — Discover Popular Movies</title>
                <meta name="description" content="Browse popular movies, search for your favorites, and discover new films on MyCinemaDB — your personal movie database powered by TMDB." />
            </Helmet>
            {!searchTerm && state.results[11] ? (
                <HeroImage
                    image={`${IMAGE_BASE_URL}${BACKDROP_SIZE}${state.results[11].backdrop_path}`}
                    title={state.results[11].original_title}
                    text={state.results[11].overview}
                />
            ) : null}
            <SearchBar setSearchTerm={setSearchTerm} />
            <Grid header={searchTerm ? 'Search Results' : 'Popular Movies'}>
                {state.results.map(movie => (
                    <Thumb
                        key={movie.id}
                        clickable={true}
                        poster={
                            movie.poster_path
                                ? IMAGE_BASE_URL + POSTER_SIZE + movie.poster_path
                                : NoImage
                        }
                        movieId={movie.id}
                        title={movie.title}
                    />
                ))}
            </Grid>
            {loading && <Spinner />}
            {state.page < state.total_pages && !loading && (
                <Button text='Load More' callback={() => setIsLoadingMore(true)} />
            )}
        </Fragment>
    );
};

export default Home;